export const API_URL =
  process.env.REACT_APP_API_ENDPOINT || 'http://localhost:3000/api/v1';
